import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";

import css from './MealsListComponent.module.css';
import {mealsActions} from "../../../store/slices/settings-slices";
import {MealComponent} from "../MealComponent/MealComponent";
import {baseURL} from "../../../constants";


const MealsListComponent = ({setIsOpenUpdate}) => {
    const dispatch = useDispatch();
    const {mealsArray, trigger} = useSelector(store => store.meals);

    useEffect(() => {
        dispatch(mealsActions.getAllMeals());
    }, [trigger])




    return (
        <section className={css.wrap}>
            {mealsArray && mealsArray.map(obj => <MealComponent
                key={obj.id}
                meal={obj}
            />)}
        </section>
    );
};

export {MealsListComponent};